import { Link } from 'react-router-dom';

const matchingTable = [
  {
    task: 'Рост продаж',
    solution: 'Обучение отдела продаж',
    description: 'Системное обучение менеджеров техникам продаж, работе с возражениями и выявлению потребностей.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    task: 'Слабые руководители',
    solution: 'Тренинг для руководителей',
    description: 'Развитие управленческих компетенций, лидерства, навыков делегирования и мотивации команды.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    task: 'Конфликты в команде',
    solution: 'Soft Skills',
    description: 'Развитие коммуникативных навыков, эмоционального интеллекта и умения разрешать конфликты.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    task: 'Слабая адаптация новичков',
    solution: 'Онбординг',
    description: 'Построение системы адаптации для быстрого выхода новых сотрудников на плановые показатели.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
  },
  {
    task: 'Нет системы обучения',
    solution: 'Корпоративная академия',
    description: 'Создание внутреннего учебного центра со стандартами, программами и оценкой эффективности.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
  {
    task: 'Неясен результат обучения',
    solution: 'Оценка эффективности',
    description: 'Внедрение системы оценки по модели Киркпатрика, KPI и измерение ROI обучения.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
  },
  {
    task: 'Нет сплоченности',
    solution: 'Командообразование',
    description: 'Тимбилдинги и бизнес-игры для улучшения взаимодействия и укрепления командного духа.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
  },
  {
    task: 'Нужна индивидуальная программа',
    solution: 'Разработка программ',
    description: 'Создание кастомизированной программы обучения под специфику компании и бизнес-задачи.',
    to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
  },
  {
    task: 'Сложные переговоры',
    solution: 'Тренинг по переговорам',
    description: 'Освоение стратегий переговоров, подготовки к сложным встречам и достижения win-win.',
    to: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
];

export default function HowToChoose() {
  return (
    <section id="how-choose" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Как выбрать корпоративное обучение
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Не знаете, с чего начать? Эта таблица поможет сопоставить бизнес-задачи с подходящими программами обучения.
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl border border-gray-100 overflow-hidden">
          {/* Table header */}
          <div className="hidden md:grid grid-cols-12 bg-gray-100 px-6 py-4 gap-4">
            <div className="col-span-3 font-semibold text-gray-700 text-sm">Если задача...</div>
            <div className="col-span-3 font-semibold text-gray-700 text-sm">То подойдет...</div>
            <div className="col-span-4 font-semibold text-gray-700 text-sm">Что включает</div>
            <div className="col-span-2"></div>
          </div>

          {/* Table rows */}
          <div className="divide-y divide-gray-200">
            {matchingTable.map((row, index) => (
              <div
                key={row.task}
                className={`grid md:grid-cols-12 gap-4 px-6 py-5 items-center hover:bg-white transition-colors ${index % 2 === 0 ? 'bg-gray-50/50' : ''}`}
              >
                <div className="md:col-span-3">
                  <div className="md:hidden text-xs font-semibold text-gray-400 uppercase mb-1">Если задача...</div>
                  <span className="text-sm font-semibold text-gray-900">{row.task}</span>
                </div>
                <div className="md:col-span-3">
                  <div className="md:hidden text-xs font-semibold text-gray-400 uppercase mb-1">То подойдет...</div>
                  <span className="text-sm font-medium text-teal-700">{row.solution}</span>
                </div>
                <div className="md:col-span-4">
                  <div className="md:hidden text-xs font-semibold text-gray-400 uppercase mb-1">Что включает</div>
                  <p className="text-sm text-gray-600 leading-relaxed">{row.description}</p>
                </div>
                <div className="md:col-span-2 md:text-right">
                  <Link
                    to={row.to}
                    className="inline-flex items-center gap-1 text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Узнать <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}